import { BrowserRouter } from "react-router-dom";
import Router from "./router";
import { AuthProvider } from "./screens/Components/Auth";
import SomethingWentWrongPage from "./screens/Components/SomethingWentWrong";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <ErrorBoundary fallback={<SomethingWentWrongPage />}>
              <Router />
            </ErrorBoundary>
            <ToastContainer />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
